import { type InputHTMLAttributes, type JSX, forwardRef, useState } from 'react'
import { ShowIcon, HideIcon, EmailIcon, PasswordIcon, ErrorIcon } from './icons'
import * as S from './styled'

type IconType = 'email' | 'password'

type PassInputType = 'text' | 'password'

type InputIconType = IconType | JSX.Element

interface InputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'id'> {
  id: string
  label?: string
  error?: string
  icon?: InputIconType
  mt?: number
  type: string
}

const Icon = ({ icon }: { icon: InputIconType }) => {
  if (typeof icon === 'string') {
    switch (icon) {
      case 'email':
        return <EmailIcon />
      case 'password':
        return <PasswordIcon />
      default: {
        return null
      }
    }
  } else {
    return icon
  }
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, icon, mt, type, ...props }, ref) => {
    const [passType, setPassType] = useState<PassInputType>('password')
    const toggleShowPass = () => {
      setPassType((s) => (s === 'password' ? 'text' : 'password'))
    }

    return (
      <S.Wrapper $mt={mt}>
        {label && <S.LabelText>{label}</S.LabelText>}
        <S.StyledLabel htmlFor={props.id} $error={!!error}>
          {icon && (
            <S.InputIcon>
              <Icon icon={icon} />
            </S.InputIcon>
          )}
          <S.StyledInput ref={ref} {...props} type={type === 'password' ? passType : type} />
          {error ? (
            <ErrorIcon />
          ) : (
            type === 'password' && (
              <S.ShowPass className={'show-pass'} onClick={toggleShowPass}>
                {passType === 'text' ? <HideIcon /> : <ShowIcon />}
              </S.ShowPass>
            )
          )}
        </S.StyledLabel>
      </S.Wrapper>
    )
  },
)
